import React, { useEffect } from 'react';
import { useFormState } from 'react-final-form';
import { PricingFormField } from '../../components/form/PricingFormField';
import { FormValues } from '../../components/form/utils';
import { PricingFormFieldType, PricingFormType } from '../../types/types';

type Props = {
  config: PricingFormType;
  onChange: (formValues: FormValues) => void;
};

function comparePricingFormsOrderIndex(a: PricingFormFieldType, b: PricingFormFieldType) {
  return a.orderIndex - b.orderIndex;
}

export const PricingFormFields = ({ config, onChange }: Props) => {
  const { values } = useFormState();

  useEffect(() => {
    if (config.uuid && values) {
      onChange(values);
    }
  }, [config.uuid, values, onChange]);

  const sortedArray = Object.values(config.fields ?? []).sort(comparePricingFormsOrderIndex);

  return (
    <>
      {sortedArray.map((field: PricingFormFieldType) => (
        <PricingFormField key={field.id} kind={field.kind} name={field.name} id={field.id} options={field.options} />
      ))}
    </>
  );
};
